import { ROUTE_PATH } from "./route-path";

export const USER_RESTRICTED_PATHS = [
  ROUTE_PATH.ZONESETTING,
  ROUTE_PATH.ACCOUNT_MANAGEMENT,
  ROUTE_PATH.ORGANIZATIONREGISTRATION,
  ROUTE_PATH.AUTO_RECORDING,
  ROUTE_PATH.SCREEN_SETTING
];
